import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
  GridList,
  GridTile,
} from "material-ui";
import Loading from "../../Loading";
import LiquidFillGauge from "../TaskLiquidFill";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import formatDate from "../../../../utils/formatDate";
import diffDate from "../../../../utils/diffDate";

class ProjectReportCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      query: { startDate: "", endDate: "" },
      timeEntries: { actual: 0, budgeted: 0 },
      tasks: { completed: 0, total: 0, overdue: [] },
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
        gridList: {
          display: "flex",
          flexWrap: "nowrap",
          overflowX: "auto",
        },
      },
    };

    this.renderOverdue = this.renderOverdue.bind(this);
  }

  componentWillMount() {
    console.log("Project report card");
    let { startDate, endDate, id } = this.props.project;
    let query = `startDate=${startDate}&endDate=${endDate}&id=${id}`;
    let url = `/api/teamwork/projectReportCard?${query}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false });
        this.setState({
          query: json.query,
          timeEntries: json.timeEntries,
          tasks: json.tasks,
        });
      });
  }

  renderOverdue() {
    if (this.state.tasks.overdue.length > 0) {
      let { centerStyle } = this.state.styles;
      // let tasks = this.state.tasks.overdue.slice(0, 5).sort((a, b) => {return a-b})
      return (
        <div>
          <Divider />
          <Subheader>Overdue Tasks</Subheader>
          <div style={centerStyle}>
            <BootstrapTable data={this.state.tasks.overdue.slice(0, 5)}>
              <TableHeaderColumn dataField="overdue" width="100">
                Overdue
              </TableHeaderColumn>
              <TableHeaderColumn dataField="name" isKey>
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataField="budgeted" width="100">
                Hours
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle, gridList } = this.state.styles;
      let { timeEntries, tasks, query } = this.state;
      let { projectStartDate, projectEndDate, lastModified } =
        this.props.project;
      let hoursComplete =
        timeEntries.budgeted > 0
          ? (timeEntries.actual / timeEntries.budgeted) * 100
          : 0;
      let tasksComplete =
        tasks.total > 0 ? (tasks.completed / tasks.total) * 100 : 0;
      let startDate = new Date(query.startDate);
      let endDate = new Date(query.endDate);
      return (
        <div>
          <div style={centerStyle}>
            <h2>{this.props.project.name}</h2>
          </div>
          <Divider />
          <Subheader>
            Statistics from activity between {formatDate(startDate)} and{" "}
            {formatDate(endDate)} ({diffDate(endDate, startDate)} days)
          </Subheader>
          <div style={centerStyle}>
            <GridList style={gridList} cols={3} cellHeight={"auto"}>
              <GridTile>
                <p>
                  <strong>Start Date:</strong> {projectStartDate}
                  <br />
                  <strong>End Date:</strong> {projectEndDate}
                  <br />
                  <strong>Last Modified:</strong> {lastModified}
                  <br />
                  <strong>Budgeted Hours:</strong> {timeEntries.budgeted}
                  <br />
                  <strong>Actual Hours:</strong> {timeEntries.actual}
                  <br />
                  <strong>Starred:</strong>{" "}
                  {this.props.project.starred ? "Yes" : "No"}
                  <br />
                  <strong>Responsible Parties:</strong>{" "}
                  {tasks.responsibleParties
                    ? tasks.responsibleParties.toString()
                    : "Unknown"}
                </p>
              </GridTile>
              <GridTile>
                <center>
                  <h4>Project Hours</h4>
                  <LiquidFillGauge
                    radius={65}
                    color={this.props.color}
                    percentComplete={hoursComplete}
                  />
                  <h4>
                    {timeEntries.actual} / {timeEntries.budgeted}
                  </h4>
                </center>
              </GridTile>
              <GridTile>
                <center>
                  <h4>Project Tasks</h4>
                  <LiquidFillGauge
                    radius={65}
                    color={this.props.color}
                    percentComplete={tasksComplete}
                  />
                  <h4>
                    {tasks.completed} / {tasks.total}
                  </h4>
                </center>
              </GridTile>
            </GridList>
          </div>
          {this.renderOverdue()}
        </div>
      );
    }
  }
}

export default ProjectReportCard;



// WEBPACK FOOTER //
// ./app/components/teamwork/projects/ProjectReportCard.js